import { getSemanticTextColor } from '../../../utils';
import { DefaultIconProps, DefaultIconWrapper } from '../../../utils/DefaultIconWrapper';

export const CopyContentIcon = ({
  color = 'white',
  width = 10,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4239 3.81818L10.5011 3.89539V11.1364H2.8647V0.954545H7.56022L7.63743 1.03175V2.86364C7.63743 3.39082 8.06479 3.81818 8.59197 3.81818H10.4239ZM1.91016 0.763637C1.91016 0.341892 2.25205 0 2.67379 0H7.6393C7.84183 0 8.03607 0.0804543 8.17927 0.223664L11.2319 3.27634C11.3752 3.41955 11.4556 3.61378 11.4556 3.81631V11.3273C11.4556 11.749 11.1137 12.0909 10.692 12.0909H2.67379C2.25205 12.0909 1.91016 11.749 1.91016 11.3273V0.763637ZM4.45555 6.36364C4.24468 6.36364 4.07373 6.53458 4.07373 6.74545C4.07373 6.95633 4.24468 7.12727 4.45555 7.12727H8.91009C9.12097 7.12727 9.29191 6.95633 9.29191 6.74545C9.29191 6.53458 9.12097 6.36364 8.91009 6.36364H4.45555ZM4.07373 8.97273C4.07373 8.76186 4.24468 8.59091 4.45555 8.59091H8.91009C9.12097 8.59091 9.29191 8.76186 9.29191 8.97273C9.29191 9.1836 9.12097 9.35455 8.91009 9.35455H4.45555C4.24468 9.35455 4.07373 9.1836 4.07373 8.97273Z"
        fill={getSemanticTextColor(color)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.477273 1.9082C0.740863 1.9082 0.954545 2.12189 0.954545 2.38548V13.0446H9.06818C9.33177 13.0446 9.54545 13.2582 9.54545 13.5218C9.54545 13.7854 9.33177 13.9991 9.06818 13.9991H0.795455C0.356137 13.9991 0 13.643 0 13.2037V2.38548C0 2.12189 0.213682 1.9082 0.477273 1.9082Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
